import httpAuth from "@/common/http-common";
import { Icon } from "@/views/sidebar/emoji-key/emoji-key.types";

class EmojiKeyService {
  async getEmojiIcons(clientId: number) {
    const { data } = await httpAuth().get<Icon[]>(
      '/Dashboard/GetEmojiIcons', { params: {
        clientId: clientId
      }
    });
    return data;
  }
}

export default new EmojiKeyService();
